import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { WorldClockLocalTimeLog } from '../../../models/world-clock-log.model';
import { WORLD_CLOCK_COLUMNS } from './world-clock-table-config';
import { WorldClockColumnKey } from '../../../models/world-clock-column.model';
import { BaseTableComponent } from '../../../models/base-table-component.model';
import { ZebraShadowRowsDirective } from '../../../shared/directives/zebra-shadow-rows/zebra-shadow-rows.directive';

@Component({
  selector: 'dr-ops-stream-ui-world-clock-table',
  templateUrl: './world-clock-table.component.html',
  styleUrls: ['./world-clock-table.component.scss'],
  imports: [ZebraShadowRowsDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorldClockTableComponent extends BaseTableComponent<WorldClockLocalTimeLog, WorldClockColumnKey> {
  constructor() {
    super(signal(WORLD_CLOCK_COLUMNS));
  }
}
